import { Property } from 'csstype';
import * as React from 'react';
import styled from 'styled-components';
import { buildPixelSize } from '../utils/sizings';

export interface IStackProps {
    align?: Property.AlignItems;
    columns?: Property.GridAutoColumns;
    flow?: Property.GridAutoFlow;
    gap?: global.Sizes;
    height?: string;
    inline?: boolean;
    justifyContent?: Property.JustifyContent;
    justifyItems?: Property.JustifyItems;
    maxWidth?: string;
    pad?: global.Sizes | global.Sizes[];
    rows?: Property.GridAutoRows;
    sizing?: Property.GridTemplateRows | Property.GridTemplateColumns;
    templateColumns?: string;
    debug?: boolean;
}

export const Stack: React.FC<IStackProps> = ({ children, ...styles }) => {
    return <StackedWrapper styled={styles}>{children}</StackedWrapper>;
};

const StackedWrapper = styled.div<{ styled: IStackProps }>`
    display: ${(props) => (props.styled.inline ? 'inline-grid' : 'grid')};
    gap: ${(props) => buildPixelSize(props.styled.gap)};
    padding: ${(props) => buildPixelSize(props.styled.pad)};
    align-items: ${(props) => props.styled.align || 'center'};
    justify-content: ${(props) => props.styled.justifyContent};
    justify-items: ${(props) => props.styled.justifyItems};
    grid-auto-flow: ${(props) => props.styled.flow || 'row'};
    grid-auto-columns: ${(props) => props.styled.columns};
    grid-auto-rows: ${(props) => props.styled.rows};
    grid-template-columns: ${(props) => props.styled.templateColumns};
    height: ${(props) => props.styled.height};
    max-width: ${(props) => props.styled.maxWidth};

    ${(props) => {
        if (props.styled.flow === 'row') {
            return { gridTemplateRows: props.styled.sizing };
        } else if (props.styled.flow === 'column') {
            return { gridTemplateColumns: props.styled.sizing };
        }

        return null;
    }}

    ${(props) => props.styled.debug && `
        outline: 1px solid deeppink;
        
        > * {
            outline: 1px solid blue;
        }
    `}
`;

export const VStack: React.FC<IStackProps> = (props) => <Stack {...props} flow="row" />;

export const HStack: React.FC<IStackProps> = (props) => <Stack {...props} flow="column" />;
